import Marquee from "react-fast-marquee";

const ITEMS = [
  "Professional Organization",
  "Personal Concierge",
  "Life, Organized",
  "Greater New Orleans",
  "Since 2016",
  "Your Extra Set of Hands",
];

export const Ribbon = () => (
  <div className="border-y border-navy/10 bg-white py-5" data-testid="editorial-marquee" aria-hidden="true">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-16">
          <span className="font-serif italic text-xl sm:text-2xl text-navy/80">{item}</span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
        </span>
      ))}
    </Marquee>
  </div>
);
